import fetch from "dva/fetch";
import { notification } from "antd";
import router, { routerRedux } from "dva/router";
import appInstance from "../index";

import local from "./local";

const codeMessage = {
  200: "The server successfully returned the requested data.",
  201: "New or modified data is successful.",
  202: "A request has entered the background queue (asynchronous task).",
  204: "The data was deleted successfully.",
  400: "The request was made with an error and the server did not perform any new or modified data operations.",
  401: "User does not have permission (token, username, password is incorrect).",
  403: "The user is authorized, but access is forbidden.",
  404: "The request is made for a record that does not exist and the server does not operate.",
  406: "The format of the request is not available.",
  410: "The requested resource is permanently deleted and will not be retrieved.",
  422: "A validation error occurred when creating an object.",
  500: "An error occurred on the server. Please check the server.",
  502: "Gateway error.",
  503: "The service is unavailable and the server is temporarily overloaded or maintained.",
  504: "The gateway timed out.",
};

const checkStatus = async (response, noti) => {
  if (response.status >= 200 && response.status < 300) {
    console.log(
      "%c----------------[ GET RESPONSE ]---------------- \n",
      "color:green;font-size:10px",
      response.url
    );
    return response;
  }

  console.log(
    "%c----------------[ GET RESPONSE ]---------------- \n",
    "color:red;font-size:10px",
    response
  );

  const errortext = codeMessage[response.status] || response.statusText;
  if (noti) {
    let status = response.status;
    let res = await response.json();
    switch (status) {
      case 400: {
        notification.warning({
          // message: `Lỗi ${response.status}: ${response.url}`,
          message: `Lỗi: ${status} - ${res.code}`,
          description: res.message || errortext,
          duration: process.env.REACT_APP_NOTIFICATION_ERROR
            ? Number(process.env.REACT_APP_NOTIFICATION_ERROR)
            : 10,
        });
        break;
      }
      default: {
        notification.error({
          // message: `Lỗi ${response.status}: ${response.url}`,
          message: `Lỗi: ${status} - ${res.code}`,
          description: res.message || errortext,
          duration: process.env.REACT_APP_NOTIFICATION_ERROR
            ? Number(process.env.REACT_APP_NOTIFICATION_ERROR)
            : 10,
        });
        break;
      }
    }
  }
  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};
const baseUrl  = process.env.REACT_APP_URL ? process.env.REACT_APP_URL : window.location.origin

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [option] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, option, noti = true,type) {
  console.log("type",type)
  const API_URL = `${baseUrl}/${url}`;
  // const API_URL = `http://localhost:1337/api/v1/test`;
  // https://gorest.co.in/public-api/users?_format=json&access-token=sIs166zXc7fTfU8F0woX9d6tcHaSy5_GmW99
  const options = {
    ...option,
  };

  const token = local.get("token");
  let tokenHeaders = {};
  if (token && token !== undefined) {
    // tokenHeaders['USER_TOKEN'] = token;
    tokenHeaders["X-Access-Token"] = token;
  }

  const defaultOptions = {
    // credentials: 'include',
    headers: {
      ...tokenHeaders,
      "Accept-Language": "vi-VN",
    },
  };
  const newOptions = { ...defaultOptions, ...options };
  if (
    newOptions.method === "POST" ||
    newOptions.method === "PUT" ||
    newOptions.method === "DELETE"
  ) {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = {
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        ...newOptions.headers,
      };
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      // newOptions.body is FormData
      newOptions.headers = {
        // Accept: 'application/json',
        ...newOptions.headers,
      };
    }
  }

  console.log("request -> newOptions", newOptions)
  return fetch(API_URL, newOptions)
    .then((res) => checkStatus(res, noti))
    .then((response) => {
      console.log("response", response);
      // DELETE and 204 do not return data by default
      // using .json will report an error.
      if (newOptions.method === "DELETE" || response.status === 204 || url.includes("export=true")) {
        return response.text();
      }
      return response.json();
    })
    .then(data => {
      if (!data) {
        return {"msg": "thanh cong"}
      }
      if(typeof data === "object" && data.error) {
        throw Error(data.error)
      }
      return data
    })
    .catch((e) => {
      console.log("catch e", e);
      const status = e.name;
      if (status === 401) {
        console.log(`🚀 ~ file: request.js ~ status`, status);
        console.log(
          `🚀 ~ file: request.js ~ window.location.href`,
          window.location.href
        );
        // @HACK
        /* eslint-disable no-underscore-dangle */
        /* window.g_app._store.dispatch({
          type: 'login/logout',
        }); */
        if (window.location.href != "login") {
          appInstance._store.dispatch({
            type: "auth/logout",
          });
        }
        return;
      }
      // environment should not be used
      if (process.env.NODE_ENV === "production") {
        if (status === 403) {
          appInstance._store.dispatch(
            routerRedux.replace({ pathname: "/exception/403" })
          );
          return;
        }
        if (status <= 504 && status > 500) {
          console.log("request -> appInstance", appInstance);
          appInstance._store.dispatch(
            routerRedux.replace({ pathname: "/exception/500" })
          );
          return;
        }
        if (status > 404 && status < 422) {
          appInstance._store.dispatch(
            routerRedux.replace({ pathname: "/exception/404" })
          );
          return;
        }
      }
      throw e.response || e;
    });
}
